import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import Dropdown, { ListBoxOption } from '../Dropdown';
import { onSortItemSelected } from '../../Actions/ProductFiltering.action';
import FilterTriggerButton from './FilterTriggerButton';
import ProductsTotalCount from './ProductsTotalCount';
import CategoryLayoutSelect from './CategoryLayoutSelect';
import PatternImageToggler from './PatternImageToggler';
import Listbox from '../Listbox';
import { translate } from '../../Services/translation';

const FilterBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const sortItems = useTypedSelector(
    (state) => state.productFiltering.sortCriteria?.sortItems
  );

  const onSortingChanged = (selectedOption: ListBoxOption) => {
    const sortItem = sortItems?.find(
      (s) => s.query == selectedOption.value
    );
    if (!sortItem) return;

    dispatch(onSortItemSelected(sortItem));
  };

  const optionList: ListBoxOption[] = useMemo(() => {
    if (!sortItems) return [];
    return sortItems?.map((item) => ({
      value: item.query,
      label: item.name,
      selected: item.selected,
      disabled: item.selected,
    }));
  }, [sortItems]);

  return (
    <>
      <div className="bg-white">
        <div className="mb-4 flex items-center justify-between lg:mb-0 lg:py-6">
          <div className="flex gap-6">
            <FilterTriggerButton />
            <ProductsTotalCount />
          </div>
          <div className="flex items-center gap-6">
            <CategoryLayoutSelect />
            <PatternImageToggler />
            {sortItems && (
              <div className="hidden min-w-[140px] lg:block">
                <Listbox
                  optionList={optionList}
                  continerClassName="w-full text-gray-900"
                  buttonClassName="!border-none text-sm uppercase [&_svg]:ml-2"
                  selectedOption={optionList.find((s) => s.selected)}
                  setSelectedOption={onSortingChanged}
                  inputSize="small"
                  label={translate('product.sort-by')}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterBar;
